import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const STATUS_MESSAGE_IDS = {
    loading: 'map.parcelLoading',
    empty: 'map.parcelNotFound',
    error: 'map.parcelUnavailable',
};

const statusMessage = model => {
    if (model.kind === 'uncovered') {
        return model.state ? (
            <FormattedMessage id="map.parcelNotCovered" values={{ state: model.state }} />
        ) : (
            <FormattedMessage id="map.parcelNotCoveredHere" />
        );
    }
    return <FormattedMessage id={STATUS_MESSAGE_IDS[model.kind] || 'map.parcelUnavailable'} />;
};

const InfoBubbleParcel = ({ model }) => (
    <div className="self-storage-info-bubble feature-group" data-testid="parcel-info-bubble">
        <div className="padded-16 selectable-text">
            <h4>
                <FormattedMessage id="map.parcelTitle" />
            </h4>
        </div>
        {model.kind === 'parcel' ? (
            <div>
                <ul>
                    {model.rows.map(row => (
                        <li key={row.labelId || row.label} className="data-row selectable-text">
                            <div className="data-row__label data-row__label--no-width selectable-text">
                                {row.labelId ? <FormattedMessage id={row.labelId} /> : row.label}
                            </div>
                            <div className="data-row__layer-library-value selectable-text">
                                {row.value}
                            </div>
                        </li>
                    ))}
                </ul>
                <div className="padded-16 selectable-text">
                    <FormattedMessage id="map.parcelSource" values={{ source: model.source }} />
                </div>
            </div>
        ) : (
            <div className="padded-16 selectable-text" data-testid="parcel-info-bubble-status">
                {statusMessage(model)}
            </div>
        )}
    </div>
);

InfoBubbleParcel.propTypes = {
    model: PropTypes.shape({ kind: PropTypes.string.isRequired }).isRequired,
};

export default InfoBubbleParcel;
